import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Constants
import { SORT } from './Request.constants';
export var getSortRequest = function getSortRequest(sortField) {
  var sortOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SORT.DESC;
  return {
    field: sortField,
    order: sortOrder
  };
};
export var getTekScriptSortRequest = function getTekScriptSortRequest(order, sortKey, sortIdOrCode) {
  var script = {
    type: 'STORED',
    idOrCode: sortIdOrCode
  };
  var tekScriptSort = {
    script: script,
    scriptSortType: 'NUMBER'
  };
  var baseSortRequest = getSortRequest(sortKey, order);
  return _objectSpread(_objectSpread({}, baseSortRequest), {}, {
    tekScriptSort: tekScriptSort
  });
};